module.exports = __webpack_public_path__ + "static/media/logo-full-pos.54ac4e95.svg";